import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const DEBOUNCE_TIME_IN_MILLISECONDS = 800;

export enum SubstantialChangesType {
  NonSovereingn = 1,
  Sovereingn = 2
}

export enum LanguageIdOptions {
  es = 1,
  en = 2,
  pt = 3,
  fr = 4
}

export const useModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 'auto',
      flexGrow: 1,
      minWidth: 300,
      transform: 'translateZ(0)',
      '@media all and (-ms-high-contrast: none)': {
        display: 'none',
      },
    },
    modal: {
      display: 'flex',
      padding: theme.spacing(1),
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: 480,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: '24px',
      borderRadius: '16px',
      border: 'none',
      height: 'auto',
      gap: '48px',
    },
  }),
);